<div class="col-12">
  <div class="col-12 align-right">
    <button type="button" [icon]="'fa fa-hand-o-right'" [disabled]="!nextEnabled()"
            [label]="'COMMON.NEXT' | translate" pButton (click)="nextStep()"></button>
  </div>
</div>
<div class="col-12">
  <div class="col-6">
    <div class="flex w-full justify-content-center">
      <div class="col-3">
        <p-radioButton name="unitPubli" [value]="ErlTypeEnum.ERL_UNIT" [label]="'UPLOAD_COMPONENT.ERL_UNIT' | translate"
                       [(ngModel)]="erlType" inputId="erlType" (onClick)="onChangeErlType()"></p-radioButton>
      </div>

      <div class="col-3">
        <p-radioButton name="unitPubli" [value]="ErlTypeEnum.ERL_PUBLI" [label]="'UPLOAD_COMPONENT.ERL_PUBLI' | translate"
                       [(ngModel)]="erlType" inputId="erlType" (onClick)="onChangeErlType()"></p-radioButton>
      </div>
    </div>
  </div>
</div>

<div class="col-12">
  <div class="col-6">
    <p-fieldset [legend]="'UPLOAD_COMPONENT.LRE_LRE_LABEL' | translate">
      <ng-template pTemplate="content">
        <div class="grid">
          <div class="col-12">
            <div class="col-12">
              <label class="col-3" for="lreSubject">{{'UPLOAD_COMPONENT.LRE_SUBJECT_LABEL' | translate}}</label>
              <input class="col-9" id="lreSubject" pInputTextarea
                     [ngClass]="{'valid': this.lreObject.subject , 'not-valid': !this.lreObject.subject}"
                     [(ngModel)]="lreObject.subject" type="text" size="30" />
            </div>
          </div>
        </div>
      </ng-template>
    </p-fieldset>
</div>
</div>

<div class="col-12" *ngIf="erlType === ErlTypeEnum.ERL_UNIT">
  <div class="col-6">
    <p-fieldset [legend]="'UPLOAD_COMPONENT.LRE_RECIPIENT_LABEL' | translate">
      <ng-template pTemplate="content">
        <div class="grid">
          <div class="col-12">
            <div class="col-3 title-input">
              {{'COMMON.SIGNER.TITLE' | translate}}
            </div>
            <div class="col-9">
              <p-dropdown [options]="signerQualityItems$ | async"
                          (ngModelChange)="onTypeActorChange('recipient', $event)"
                          [(ngModel)]="lreObject.recipient.signerQuality"></p-dropdown>
            </div>
          </div>
          <div class="col-12 content-margin-space" *ngIf="lreObject.recipient.signerQuality === SignerQualityEnum.INDIVIDUAL">
            <!-- recipient.title -->
            <div class="col-2">
              <p-dropdown [filter]="false" [options]="titleItems$ | async"
                          [(ngModel)]="lreObject.recipient.title"></p-dropdown>
            </div>
            <!-- recipient.firstName -->
            <div class="col-5">
                  <span class="p-float-label">
                    <input id="recipientFirstName"
                           [ngClass]="{'valid': this.lreObject.recipient.firstName , 'not-valid': !this.lreObject.recipient.firstName}"
                           [(ngModel)]="lreObject.recipient.firstName" type="text" size="30" pInputText>
                    <label for="recipientFirstName">{{'UPLOAD_COMPONENT.LRE_S_FIRSTNAME_LABEL' | translate}}</label>
                  </span>
            </div>
            <!-- recipient.lastName -->
            <div class="col-5">
                  <span class="p-float-label">
                    <input id="recipientLastName"
                           [ngClass]="{'valid': this.lreObject.recipient.lastName , 'not-valid': !this.lreObject.recipient.lastName}"
                           [(ngModel)]="lreObject.recipient.lastName" type="text" size="30" pInputText>
                    <label for="recipientLastName">{{'UPLOAD_COMPONENT.LRE_S_LASTNAME_LABEL' | translate}}</label>
                  </span>
            </div>
          </div>
          <div class="col-12" *ngIf="lreObject.recipient.signerQuality === SignerQualityEnum.PROFESSIONAL">
              <label class="col-3" for="recipientcompany">{{'UPLOAD_COMPONENT.LRE_S_COMPANY_LABEL' | translate}}</label>
              <input class="col-9" id="recipientcompany" pInputTextarea
                     [ngClass]="{'valid': this.lreObject.recipient.company , 'not-valid': !this.lreObject.recipient.company}"
                     [(ngModel)]="lreObject.recipient.company" type="text" size="30">
          </div>
          <div class="col-12">
            <!-- recipient.mailAddress -->
            <label class="col-3" for="recipientmailAddress">{{'UPLOAD_COMPONENT.LRE_S_MAIL_LABEL' | translate}}</label>
            <input class="col-9" id="recipientmailAddress"
                   [ngClass]="{'valid': isValidMail(lreObject.recipient.mailAddress), 'not-valid': !isValidMail(lreObject.recipient.mailAddress)}"
                   [(ngModel)]="lreObject.recipient.mailAddress" type="text" size="30" pInputText>
          </div>
          <div class="col-12" [ngClass]= "{'content-margin-space': lreObject.recipient.authenticationType === AuthTypeEnum.SMS}">
            <!-- recipient.authenticationType -->
            <div class="col-3">
              <p-dropdown [filter]="false" [options]="authTypeItems$ | async"
                          (ngModelChange)="onAuthenticationChange('recipient', $event)"
                          [(ngModel)]="lreObject.recipient.authenticationType"></p-dropdown>
            </div>
            <!-- recipient.phoneNumber -->
            <div class="col-9" *ngIf="lreObject.recipient.authenticationType === AuthTypeEnum.SMS">
                  <span class="p-float-label">
                    <input id="recipientphoneNumber"
                           [ngClass]="{'valid': this.lreObject.recipient.phoneNumber , 'not-valid': !this.lreObject.recipient.phoneNumber}"
                           [(ngModel)]="lreObject.recipient.phoneNumber " type="text" size="30" pInputText>
                    <label for="recipientphoneNumber">{{'UPLOAD_COMPONENT.LRE_S_PHONE_LABEL' | translate}}</label>
                  </span>
            </div>
            <div class="col-6" *ngIf="lreObject.recipient.authenticationType !== AuthTypeEnum.SMS">&nbsp;</div>
          </div>

        </div>
      </ng-template>
    </p-fieldset>
  </div>
</div>

<div class="col-12">
  <div class="col-6">
    <p-fieldset [legend]="'UPLOAD_COMPONENT.LRE_SENDER_LABEL' | translate">
      <ng-template pTemplate="content">
        <div class="grid">
          <div class="col-12">
            <div class="col-3 title-input">
              {{'COMMON.SIGNER.TITLE' | translate}}
            </div>
            <div class="col-9">
              <p-dropdown [options]="signerQualityItems$ | async"
                          (ngModelChange)="onTypeActorChange('sender', $event)"
                          [(ngModel)]="lreObject.sender.signerQuality"></p-dropdown>
            </div>
          </div>
          <div class="col-12 content-margin-space" *ngIf="lreObject.sender.signerQuality === SignerQualityEnum.INDIVIDUAL">
            <!-- recipient.title -->
            <div class="col-2">
              <p-dropdown [filter]="false" [options]="titleItems$ | async"
                          [(ngModel)]="lreObject.sender.title"></p-dropdown>
            </div>
            <!-- recipient.firstName -->
            <div class="col-5">
                  <span class="p-float-label">
                    <input id="senderFirstName"
                           [ngClass]="{'valid': this.lreObject.sender.firstName , 'not-valid': !this.lreObject.sender.firstName}"
                           [(ngModel)]="lreObject.sender.firstName" type="text" size="30" pInputText>
                    <label for="senderFirstName">{{'UPLOAD_COMPONENT.LRE_S_FIRSTNAME_LABEL' | translate}}</label>
                  </span>
            </div>
            <!-- recipient.lastName -->
            <div class="col-5">
                  <span class="p-float-label">
                    <input id="senderLastName"
                           [ngClass]="{'valid': this.lreObject.sender.lastName , 'not-valid': !this.lreObject.sender.lastName}"
                           [(ngModel)]="lreObject.sender.lastName" type="text" size="30" pInputText>
                    <label for="senderLastName">{{'UPLOAD_COMPONENT.LRE_S_LASTNAME_LABEL' | translate}}</label>
                  </span>
            </div>
          </div>
          <div class="col-12" *ngIf="lreObject.sender.signerQuality === SignerQualityEnum.PROFESSIONAL">
            <label class="col-3" for="senderCompany">{{'UPLOAD_COMPONENT.LRE_S_COMPANY_LABEL' | translate}}</label>
            <input class="col-9" id="senderCompany" pInputTextarea
                   [ngClass]="{'valid': this.lreObject.sender.company , 'not-valid': !this.lreObject.sender.company}"
                   [(ngModel)]="lreObject.sender.company" type="text" size="30">
          </div>
          <div class="col-12">
            <!-- recipient.mailAddress -->
            <label class="col-3" for="senderMailAddress">{{'UPLOAD_COMPONENT.LRE_S_MAIL_LABEL' | translate}}</label>
            <input class="col-9" id="senderMailAddress"
                   [ngClass]="{'valid': isValidMail(lreObject.sender.mailAddress), 'not-valid': !isValidMail(lreObject.sender.mailAddress)}"
                   [(ngModel)]="lreObject.sender.mailAddress" type="text" size="30" pInputText>
          </div>
          <div class="col-12" [ngClass]= "{'content-margin-space': lreObject.sender.authenticationType === AuthTypeEnum.SMS}">
            <!-- recipient.authenticationType -->
            <div class="col-3">
              <p-dropdown [filter]="false" [options]="authTypeItems$ | async"
                          (ngModelChange)="onAuthenticationChange('sender', $event)"
                          [(ngModel)]="lreObject.sender.authenticationType"></p-dropdown>
            </div>
            <!-- recipient.phoneNumber -->
            <div class="col-9" *ngIf="lreObject.sender.authenticationType === AuthTypeEnum.SMS">
                  <span class="p-float-label">
                    <input id="senderPhoneNumber"
                           [ngClass]="{'valid': this.lreObject.sender.phoneNumber , 'not-valid': !this.lreObject.sender.phoneNumber}"
                           [(ngModel)]="lreObject.sender.phoneNumber " type="text" size="30" pInputText>
                    <label for="senderPhoneNumber">{{'UPLOAD_COMPONENT.LRE_S_PHONE_LABEL' | translate}}</label>
                  </span>
            </div>
            <div class="col-6" *ngIf="lreObject.sender.authenticationType !== AuthTypeEnum.SMS">&nbsp;</div>
          </div>

          <!-- sender.finalAddress -->
          <div class="col-12">
            <div class="col-3">
              <label for="senderAddress">{{'UPLOAD_COMPONENT.LRE_S_ADDRESS_LABEL' | translate}}</label>
            </div>
            <div class="col-7">
              <textarea id="senderAddress" rows="5" [readOnly]="true" class="w-full"
                        [ngClass]="{'not-valid': !isValidAddress(lreObject.sender.address), 'valid': isValidAddress(lreObject.sender.address) }"
                        [(ngModel)]="lreObject.sender.address" pInputTextarea [autoResize]="false"></textarea>
            </div>
            <div class="col-2">
              <button pButton type="button" [icon]="'fa fa-pencil'" class="p-button-info"
                      [label]="'COMMON.EDIT' | translate"
                      (click)="showSenderAddress()"></button>
              <p-dialog *ngIf="openSenderAddress" [(visible)]="openSenderAddress" [styleClass]="'adressModal'"
                        [appendTo]="'body'"
                        [header]="'FOLD.ACTION_COMPONENT.ADD_MODAL_TITLE' | translate"
                        [draggable]="false"
                        [closable]="true"
                        [resizable]="false"
                        [modal]="true" [closeOnEscape]="false">
                <app-address (finalAddress)="handleSenderAddress($event)"
                             (visible)="handleSenderAddressClose($event)"
                             [oldAddress]="currentSenderAddress"></app-address>
              </p-dialog>
            </div>
          </div>
        </div>
      </ng-template>
    </p-fieldset>
  </div>
</div>
